import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { APPLICATION_FOUND_URL, CREDIT_PORTAL_URL, NO_APPLICATIONS_URL, } from 'shared';
import * as apiActions from 'api-actions';
import LoginImage from 'images/PMP_Login_Image.png';
import { ApplicationFinderForm } from '../../forms';
const logo = '/Alphaeon_Patient_Financing_Logo_SVG.svg';
function ApplicationFinder({ getCreditApplicationsByStatus, }) {
    const history = useHistory();
    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = (formValues) => {
        setSubmitting(true);
        getCreditApplicationsByStatus(formValues, 'prequalified')
            .then(() => {
            history.push(APPLICATION_FOUND_URL);
        })
            .catch(() => {
            getCreditApplicationsByStatus(formValues, 'pending')
                .then(() => {
                history.push(APPLICATION_FOUND_URL);
            })
                .catch(() => {
                history.push(NO_APPLICATIONS_URL);
            });
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    return (_jsxs("div", { className: "application-finder-container min-height-600", children: [_jsx("div", { className: "left-content-container", children: _jsx("img", { src: LoginImage, alt: "Person holding an Alphaeon credit card" }) }), _jsxs("div", { className: "right-content-container", children: [_jsxs("header", { children: [_jsx("img", { className: "logo", src: logo, alt: "Alphaeon logo", width: 224, height: 58.75 }), _jsx("h1", { children: "Let's Find Your Application" })] }), _jsx(ApplicationFinderForm, { handleSubmit: handleSubmit, submitting: submitting }), _jsxs("p", { children: ["Haven't applied yet? ", _jsx(Link, { to: CREDIT_PORTAL_URL, children: "Apply" })] })] })] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {
    getCreditApplicationsByStatus: apiActions.getCreditApplicationsByStatus,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ApplicationFinder);
